import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {ApiUrl} from '@emm/core/util/api-url.token';
import {LocationSetType} from '@emm/core/models/location-set-type.model';
import {API} from '@emm/core/util/api-constants';
import {standardRetry} from '@emm/core/util/rx.util';

@Injectable({
    providedIn: 'root',
})
export class LocationSetTypeService {

    constructor(@Inject(ApiUrl) private apiUrl: string, private http: HttpClient) {}



    getAllLocationSetTypes(): Observable<LocationSetType[]> {
        const url = `${this.apiUrl}${API.AllLocationSetTypes}`;
        return this.http.get(url).pipe(
            map((response) => response),
            standardRetry()
        );
    }



    getAllLocationSetTypesForEdit(): Observable<LocationSetType[]> {
        return this.http
            .get(
                `${this.apiUrl}/location-set-types/findAllForEdit`
            )
            .pipe(
                map((response) => response),
                standardRetry()
            );
    }



    deleteLocationSetType(locationSetTypeTag: string): Observable<any> {
        return this.http
            .delete(`${this.apiUrl}/location-set-types/${locationSetTypeTag}`)
            .pipe(standardRetry());
    }



    createLocationSetType(locationSetType: {
        description: string;
        locked: boolean;
        name: string;
        tag: string;
        weight: number;
    }): Observable<any> {
        return this.http
            .post(`${this.apiUrl}/location-set-types`, locationSetType)
            .pipe(standardRetry());
    }



    getLocationSetType(locationSetTypeTag: string): Observable<LocationSetType> {
        return this.http
            .get(`${this.apiUrl}/location-set-types/${locationSetTypeTag}?projection=details`)
            .pipe(standardRetry());
    }



    updateLocationSetType(
        locationSetTypeTag: string,
        locationSetType: LocationSetType
    ): Observable<LocationSetType> {
        return this.http
            .put(`${this.apiUrl}/location-set-types/${locationSetTypeTag}`, locationSetType)
            .pipe(standardRetry());
    }



}
